import React, { useEffect, useRef, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import { delete_cart, get_estimate_mono, get_select_one_estimate, update_estimate_memo } from "../../Axios";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import Pagination from "../Utility/Pagination";
import { commaPrice } from "../../Validation";
import arrowIcon from "../../assets/icons/arrow_forward_ios.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { reduxAddReservationSelectedProduct, reduxChangePostcode3, reduxChangePostcode4, reduxChangeReservationDivision, reduxChangeReservationHighStatus, reduxResetReservation } from "../../redux/ReservationSlice";
import { PostCode, SelectedProduct } from "../../model/product";

interface IndividualList {
    estimate_ID                           : number;
    estimate_group_ID                     : number;
    estimate_brand_ID                     : number;
    estimate_color_ID                     : number;
    estimate_quantity                     : number;
    estimate_construction_reservation_pay : number;
    estimate_registe                      : string;
    estimate_color_name                   : string;
    estimate_product_name                 : string;
    estimate_division_name                : string;
    estimate_high_status_name             : string;
    brand_kor_name                        : string;
    product_kor_name                      : string;
    estimate_customer_address_1_sido      : string;
    estimate_customer_address_1_sigungu   : string;
    estimate_customer_address_2_sido      : string;
    estimate_customer_address_2_sigungu   : string;
    estimate_memo                         : string;
};

const ShoppingBag: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customerData = useSelector((state:RootState) => state.customerData);
    const [estimateList, setEstimateList] = useState<IndividualList[]>([]);
    const [selectedEstimate, setSelectedEstimate] = useState<number[]>([]);
    const [memoList, setMemoList] = useState<string[]>([]);
    // const [individualList, setIndividualList] = useState<IndividualList[]>([]);
    
    const [totalEstimate, setTotalEstimate] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [field, setField] = useState<number>(0); // 정렬하는 필드 0 : PK
    const [listOrder, setListOrder] = useState<number>(0); // 상하행 정렬 0 : DESC, 1 : ASC

    const checkAllRef: React.RefObject<HTMLInputElement> = useRef(null);

    useEffect(() => {
        if(!page) return;
        if(!customerData.customer_ID) return;
        handleSelectEstimateList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData.customer_ID, page, field, listOrder]);

    const handleSelectEstimateList = () => {
        get_estimate_mono(customerData.customer_ID, page, field, listOrder).then(result => {
            let list = [];
            for(const memo of result.rows) {
                list.push(memo.estimate_memo);
            };
            setMemoList(list);
            setEstimateList(result.rows);
            setTotalEstimate(result.total_count);
        })
    }

    // check 된 estimate_ID들만 배열에 담아서 오름차순으로 정렬
    const handleSelectCheckList = (e: React.ChangeEvent<HTMLInputElement>) => {
        const id = parseInt(e.target.value);
        let list = [...selectedEstimate];
        if(e.target.checked) {
            list.push(id);
        } else {
            list = list.filter(el => el !== id);
        };
        list.sort((a, b) => a-b);
        setSelectedEstimate(list);
    };

    // 전체 선택
    const handleSelectAllCheck = () => {
        let list = [];
        for (const item of estimateList) {
            list.push(item.estimate_ID);
        };
        if(selectedEstimate.length === list.length) {
            setSelectedEstimate([]);
        } else {
            list.sort((a, b) => a-b);
            setSelectedEstimate(list);
        };
    };

    // 페이지 바뀔 시 이전에 선택한 체크박스 해제
    useEffect(() => {
        setSelectedEstimate([]);
    }, [page]);

    useEffect(() => {
        if (selectedEstimate.length === estimateList.length) {
            if (checkAllRef.current) {
                checkAllRef.current.checked = true;
            }
        } else {
            if (checkAllRef.current) {
                checkAllRef.current.checked = false;
            }
        }
    }, [estimateList.length, selectedEstimate.length, checkAllRef]);

    const handlePage = (page: number) => {
        setPage(page);
    };

    const handleSort = (field_num: number) => {
        if(field !== field_num) {
            setField(field_num);
            setListOrder(1);
        } else {
            if(listOrder === 1) {
                setListOrder(0);
            } else if (listOrder === 0) {
                setField(0)
            }
        };
        setPage(1) // 정렬시 1페이지로 이동 => 삭제해도 무방
    };

    return (
        <S.SectionContainer>
            <S.SectionWidth $width={900}>
                <S.SectionTitleBox>
                    <h1>견적 장바구니</h1>
                    <h3>A.Black 견적 장바구니 입니다. 견적 변경 및 바로 예약을 할 수 있습니다.</h3>
                </S.SectionTitleBox>

                <div className="flex justify-between pr-2 pl-[22px] mt-[50px] text-[12px] font-semibold">
                    <div className="flex items-center cursor-pointer" onClick={() => {
                        handleSelectAllCheck();
                    }}>
                        <input type="checkbox" ref={checkAllRef} className="accent-pointOrange cursor-pointer" />
                        <button className="ml-1 pt-[1.8px]">전체 선택</button>
                    </div>

                    {estimateList.length > 0 &&
                    <div className="flex justify-between items-center pr-2 pl-2 text-[12px] font-semibold">
                        <div
                            className="flex justify-end"
                            onClick={() => {
                                if(!selectedEstimate.length) return alert('선택된 항목이 없습니다.');
                                if(!window.confirm('선택하신 항목들을 삭제하시겠습니까?')) return;
                                delete_cart(customerData.customer_ID, selectedEstimate).then(result => {
                                    if(result === 1) {
                                        alert('삭제되었습니다.');
                                        handleSelectEstimateList();
                                    } else {
                                        alert('정상적으로 처리되지 않았습니다.');
                                    }
                                });
                            }}
                        >
                            <button>선택 삭제</button>
                        </div>
                    </div>
                }
                </div>

                <S.ReservationTableHead className="mt-2">
                    <div className="w-[48px] cursor-default">선택</div>
                    <div className="sortable-box w-[50px]" onClick={() => handleSort(1)}>
                        <span>
                            구분
                            <img src={arrowIcon} className={`${field === 1 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div
                        className="sortable-box w-[280px]"
                        // onClick={() => handleSort(2)}
                    >
                        <span>
                            서비스 내용
                            <img src={arrowIcon} className={`${field === 2 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-[24%]">
                        <span>
                            메모
                            <span className="font-light">
                                &nbsp;(클릭시 메모 가능)
                            </span>
                            <img src={arrowIcon} className={`${field === 3 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="sortable-box w-[100px]" onClick={() => handleSort(6)}>
                        <span>
                            견적
                            <img src={arrowIcon} className={`${field === 6 ? `block ${listOrder === 0 ? "rotate-90" : "rotate-[270deg]"}` : "hidden"}`} alt="" />
                        </span>
                    </div>
                    <div className="w-[100px] cursor-default">견적 관리</div>
                </S.ReservationTableHead>

                <div>
                    {estimateList.map((tmp, idx) =>
                        <S.ShoppingTableBody className="h-32" key={tmp.estimate_ID} $withBtn={true} onClick={() => {
                        }}>
                            <input
                                className="accent-pointOrange cursor-pointer w-[48px]"
                                type="checkbox"
                                value={tmp.estimate_ID}
                                checked={selectedEstimate.includes(tmp.estimate_ID)}
                                onChange={handleSelectCheckList}
                            />
                            <div className="w-[50px]">{tmp.estimate_division_name}</div>
                            <div className="w-[280px] text-left leading-[22px] font-normal">
                                <p>
                                    &bull;{tmp.estimate_high_status_name}
                                </p>
                                <p>
                                    &bull;{tmp.brand_kor_name}
                                </p>
                                <p className="w-[270px] whitespace-nowrap overflow-hidden text-ellipsis">
                                    &bull;{tmp.product_kor_name} / {tmp.estimate_color_name}
                                </p>
                                <p>
                                    &bull;{tmp.estimate_quantity} 개
                                </p>
                                {tmp.estimate_division_name === "이전설치" &&
                                    <p>
                                        &bull;{tmp.estimate_customer_address_1_sido} {tmp.estimate_customer_address_1_sigungu} (이동 : {tmp.estimate_customer_address_2_sido} {tmp.estimate_customer_address_2_sigungu})
                                    </p>
                                }
                            </div>
                            <div className="w-[24%] request-box text-[14px]">
                                {/* 
                                    메모 바로 update 하기에는 제약이 많아서 따로 해당 페이지 list state 만들어서 거기서 바꾸고,
                                    포커스 잃을 때 post 하는 형식으로 만듦
                                */}
                                <textarea
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        let list = [...memoList];
                                        list[idx] = value;
                                        setMemoList(list);
                                    }}
                                    value={memoList[idx] ? memoList[idx] : ""}
                                    onBlur={() => {
                                        update_estimate_memo(
                                            customerData.customer_ID,
                                            tmp.estimate_ID,
                                            memoList[idx]
                                        );
                                    }}
                                    rows={4}
                                    maxLength={50}
                                    className="w-[100%] resize-none outline-none underline placeholder:text-center placeholder:underline placeholder:pt-8"
                                    placeholder="50자 내 메모를 작성할 수 있습니다."
                                >
                                    {memoList[idx]}
                                </textarea>
                            </div>
                            <div className="w-[100px] leading-4">
                                <p className="text-[16px] font-semibold">
                                    {commaPrice(tmp.estimate_construction_reservation_pay)}
                                </p>
                                <p className="text-[12px]">
                                    AP포인트
                                </p>
                            </div>
                            
                            <div className="w-100px">
                                {/* <div className="w-[100px] estimate-management-button modify-btn">
                                    변경하기
                                </div> */}
                                <div className="w-[100px] estimate-management-button reservation-btn" onClick={() => {
                                    // TODO: 이거 컨펌 창에서 견적 정보 요약해서 보여줄 수 있도록 하자
                                    if(!window.confirm('해당 제품을 예약하시겠습니까?')) return;
                                    get_select_one_estimate(customerData.customer_ID, tmp.estimate_ID).then(result => {
                                        const productObj :SelectedProduct = {
                                            product_ID   : result.estimate_color_ID,
                                            construction_ID : undefined,
                                            product_name : `${tmp.product_kor_name} - ${tmp.estimate_color_name}`,
                                            quantity     : result.estimate_quantity,
                                            brand_ID     : result.estimate_brand_ID,
                                            brand_kor_name   : result.brand_kor_name
                                        };
                                        dispatch(reduxResetReservation());
                                        dispatch(reduxChangeReservationDivision(result.estimate_division));
                                        dispatch(reduxAddReservationSelectedProduct(productObj));
                                        dispatch(reduxChangeReservationHighStatus(result.estimate_high_status));
                                        if(result.estimate_high_status === 3) {
                                            const postCode3: PostCode = {
                                                zip_code       : result.estimate_customer_address_1_zip_code,
                                                address        : result.estimate_customer_address_1_address,
                                                detail_address : result.estimate_customer_address_1_detail_address,
                                                sido           : result.estimate_customer_address_1_sido,
                                                sigungu        : result.estimate_customer_address_1_sigungu,
                                            };
                                            const postCode4: PostCode = {
                                                zip_code       : result.estimate_customer_address_2_zip_code,
                                                address        : result.estimate_customer_address_2_address,
                                                detail_address : result.estimate_customer_address_2_detail_address,
                                                sido           : result.estimate_customer_address_2_sido,
                                                sigungu        : result.estimate_customer_address_2_sigungu,
                                            };
                                            dispatch(reduxChangePostcode3(postCode3));
                                            dispatch(reduxChangePostcode4(postCode4));
                                        };
                                        navigate('/reservation');
                                    })
                                }}>
                                    바로예약
                                </div>

                                <div
                                    className="w-[100px] estimate-management-button delete-btn"
                                    onClick={() => {
                                        if(!window.confirm('삭제 하시겠습니까?')) return;
                                        delete_cart(
                                            customerData.customer_ID, [tmp.estimate_ID]
                                        ).then(result => {
                                            if(result === 1) {
                                                alert('삭제되었습니다.');
                                                handleSelectEstimateList();
                                            } else {
                                                alert('정상적으로 처리되지 않았습니다.');
                                            }
                                        })
                                    }}
                                >
                                    삭제하기
                                </div>
                            </div>
                        </S.ShoppingTableBody>
                    )}
                </div>

                <Pagination totalCount={totalEstimate} handlePage={handlePage} listCount={10} page={page} />
                        
                <br />
                <br />
                <br />
                <br />
            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default ShoppingBag;